import { PureComponent } from 'react';
import mapProps from 'map-props';
import PropTypes from 'prop-types';
import formValues from 'helpers/form/formValues';
import { SelectControl } from 'components/forms/Select';
import { MILEAGE_RANGE_NAME } from 'components/searchAds/constants';
import { MIN, MAX } from 'helpers/fieldOptions';
import propsMapping from '../propsMapping';

const MIN_NAME = `${MILEAGE_RANGE_NAME}.min`;
const MAX_NAME = `${MILEAGE_RANGE_NAME}.max`;

class MileageControl extends PureComponent {
  static propTypes = {
    rangeType: PropTypes.oneOf([MIN, MAX]),
  };

  render() {
    return <SelectControl {...this.props} />;
  }
}

export default formValues(({ rangeType, compareValue }) => {
  const result = { value: MILEAGE_RANGE_NAME };

  if (compareValue) return result;

  return {
    ...result,
    compareValue: rangeType === MAX ? MIN_NAME : MAX_NAME,
  };
})(mapProps(propsMapping)(MileageControl));
